import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AddCategory = () => {
  const navigate = useNavigate();
  const baseUrl = import.meta.env.VITE_API_BASE_URL; // ✅ Your backend base URL

  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    description: "",
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
    image: null as File | null,
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "name") toSeoUrl(value);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFormData((prev) => ({ ...prev, image: e.target.files![0] }));
    }
  };

  const toSeoUrl = (url: string) => {
    const weburl = url
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-")
      .toLowerCase()
      .replace(/&/g, "-and-")
      .replace(/[^a-z0-9\-]/g, "")
      .replace(/-+/g, "-")
      .replace(/^-*/, "")
      .replace(/-*$/, "");
    setFormData((prev) => ({ ...prev, slug: weburl }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value) data.append(key, value as any);
    });

    try {
      await axios.post(`${baseUrl}/category`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("✅ Category added successfully!");
      navigate("/settings/category");
    } catch (err: any) {
      console.error("Error adding category:", err.response?.data || err.message);
      alert(err.response?.data?.message || "Failed to add category!");
    }
  };

  return (
    <div className="main-container container-fluid">
      <div className="page-header">
        <h1 className="page-title">Add Category</h1>
      </div>

      <div className="row">
        <div className="col-xl-12 col-md-12">
          <form
            className="card"
            onSubmit={handleSubmit}
            encType="multipart/form-data"
          >
            <div className="card-body">
              <div className="form-group">
                <label className="form-label">Category Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Slug URL</label>
                <input
                  type="text"
                  className="form-control"
                  name="slug"
                  value={formData.slug}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                ></textarea>
              </div>

              <div className="form-group">
                <label className="form-label">Category Icon</label>
                <input
                  type="file"
                  className="form-control"
                  name="image"
                  accept="image/*"
                  onChange={handleFileChange}
                />
                <small>Recommended: 50px × 50px</small>
              </div>

              <div className="form-group">
                <label className="form-label">Meta Title</label>
                <input
                  type="text"
                  className="form-control"
                  name="meta_title"
                  value={formData.meta_title}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Meta Description</label>
                <textarea
                  className="form-control"
                  name="meta_description"
                  value={formData.meta_description}
                  onChange={handleChange}
                ></textarea>
              </div>

              <div className="form-group">
                <label className="form-label">Meta Keywords</label>
                <textarea
                  className="form-control"
                  name="meta_keywords"
                  value={formData.meta_keywords}
                  onChange={handleChange}
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;
